import http from "helpers/http";

const UPDATE_CURRENT_USER = "auth/UPDATE_CURRENT_USER";
const UPDATE_TOKEN = "auth/UPDATE_TOKEN";
const SHOW_LOGIN_MODAL = "auth/SHOW_LOGIN";
const LOGOUT = "auth/LOGOUT";
const SAVE_TOKEN = "auth/SAVE_TOKEN";
const SAVE_ENV = "auth/SAVE_ENV";

export const initialState = {
  token: undefined,
  currentUser: undefined,
  isLoginModalShowing: false,
};

export const showLoginModal = isLoginModalShowing => ({
  type: SHOW_LOGIN_MODAL,
  payload: {
    isLoginModalShowing,
  },
});

export const updateCurrentUser = currentUser => ({
  type: UPDATE_CURRENT_USER,
  payload: {
    currentUser,
  },
});

export const updateToken = token => ({
  type: UPDATE_TOKEN,
  payload: {
    token,
  },
});

export const register = values => async (dispatch, getState) => {
  try {
    const result = await http.post("/auth/register", values);
    if (result.user) {
      dispatch(updateCurrentUser(result.user));
    }

    if (result.token) {
      dispatch(updateToken(result.token));
      window.token = result.token;
    }
    return result;
  } catch (err) {
    throw err;
  }
};

export const login = params => async (dispatch, getState) => {
  try {
    const result = await http.post("/oauth/login", params);

    if (result.token) {
      dispatch(updateToken(result.token));
      window.token = result.token;
    }
    return result;
  } catch (err) {
    throw err;
  }
};

export const logout = () => ({
  type: LOGOUT,
});

export const saveToken = token => ({
  type: SAVE_TOKEN,
  payload: {
    token,
  },
});

export const saveENV = env => ({
  type: SAVE_ENV,
  payload: {
    env,
  },
});

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_LOGIN_MODAL:
      return {
        ...state,
        isLoginModalShowing: action.payload.isLoginModalShowing,
      };
    case UPDATE_CURRENT_USER:
      return {
        ...state,
        currentUser: action.payload.currentUser,
      };
    case UPDATE_TOKEN:
      return {
        ...state,
        token: action.payload.token,
      };
    case LOGOUT:
      return {
        ...state,
        token: undefined,
        currentUser: undefined,
      };
    case SAVE_TOKEN:
      return {
        ...state,
        token: action.payload.token,
      };
    case SAVE_ENV:
      return {
        ...state,
        env: action.payload.env,
      };
    default:
      return state;
  }
};
